module.exports = __webpack_public_path__ + "img/127.bd9f9c60.png";